// extracted by mini-css-extract-plugin
export default {"TableHeader":"OfferRequestAccessTable_TableHeader__iCVfS","Icon":"OfferRequestAccessTable_Icon__Gzkkh"};